import * as squint_core from 'squint-cljs/core.js';
import { h } from 'preact';
import { useEffect, useState, useRef } from 'preact/hooks';
var keep_selection_in_viewport = function (container, selected_index) {
const container_rect_1 = container.getBoundingClientRect();
const selected_rect_2 = container.children[selected_index].getBoundingClientRect();
const delta_top_3 = (selected_rect_2.top - container_rect_1.top);
const delta_bottom_4 = (selected_rect_2.bottom - container_rect_1.bottom);
if ((delta_top_3 < 0)) {
return container.scrollBy(0, delta_top_3)} else {
if ((delta_bottom_4 > 0)) {
return container.scrollBy(0, delta_bottom_4)} else {
return null}};

};
var ListSearch = function (p__11344) {
const map___1_3 = p__11344;
const map___1_4 = ((squint_core.truth_(squint_core.sequential_QMARK_(map___1_3))) ? (((squint_core.truth_(squint_core.vector_QMARK_(map___1_3))) ? (map___1_3) : (squint_core.seq_to_map_for_destructuring(map___1_3)))) : (map___1_3));
const initialValue_5 = squint_core.get(map___1_4, "initialValue");
const place_holder_text_6 = squint_core.get(map___1_4, "place-holder-text");
const results_7 = squint_core.get(map___1_4, "results");
const rowView_8 = squint_core.get(map___1_4, "rowView");
const resultsFetcher_9 = squint_core.get(map___1_4, "resultsFetcher");
const onActivateItem_10 = squint_core.get(map___1_4, "onActivateItem");
const vec___11_20 = useState(0);
const selected_ndx_21 = squint_core.nth(vec___11_20, 0, null);
const set_selected_ndx_BANG__22 = squint_core.nth(vec___11_20, 1, null);
const input_node_23 = useRef(null);
const vec___14_24 = useState(((squint_core.truth_(initialValue_5)) ? (initialValue_5) : ("")));
const input_value_25 = squint_core.nth(vec___14_24, 0, null);
const set_input_value_BANG__26 = squint_core.nth(vec___14_24, 1, null);
const vec___17_27 = useState(0);
const refresh_28 = squint_core.nth(vec___17_27, 0, null);
const set_refresh_BANG__29 = squint_core.nth(vec___17_27, 1, null);
useEffect((function setup () {
input_node_23.current.focus();
if (squint_core.truth_(initialValue_5)) {
return resultsFetcher_9(initialValue_5);
};

}), []);
return <><div class="relative system-sans-serif"><input ref={input_node_23} value={input_value_25} onBlur={(function () {
return set_refresh_BANG__29((refresh_28 + 1));

})} class="pa2 w-100 br1 border-box b--blue ba input-reset" autofocus="true" placeHolder={place_holder_text_6} onInput={(function (e) {
const target_30 = e.target;
set_input_value_BANG__26(target_30.value);
return resultsFetcher_9(target_30.value);

})} onKeyDown={(function (p__11345) {
const map___31_33 = p__11345;
const map___31_34 = ((squint_core.truth_(squint_core.sequential_QMARK_(map___31_33))) ? (((squint_core.truth_(squint_core.vector_QMARK_(map___31_33))) ? (map___31_33) : (squint_core.seq_to_map_for_destructuring(map___31_33)))) : (map___31_33));
const e_35 = map___31_34;
const target_36 = squint_core.get(map___31_34, "target");
const key_37 = squint_core.get(map___31_34, "key");
const G__11346_38 = key_37;
switch (G__11346_38) {case "Enter":
const temp__6897__auto___40 = squint_core.get(results_7, selected_ndx_21);
if (squint_core.truth_(temp__6897__auto___40)) {
const item_41 = temp__6897__auto___40;
return onActivateItem_10(item_41);
};

break;
case "Escape":
return target_36.blur();

break;
case "ArrowUp":
e_35.preventDefault();
return set_selected_ndx_BANG__22(squint_core.max((selected_ndx_21 - 1), 0));

break;
case "ArrowDown":
e_35.preventDefault();
return set_selected_ndx_BANG__22(squint_core.min((selected_ndx_21 + 1), (squint_core.count(results_7) - 1)));

break;
};

})} onFocus={(function () {
set_selected_ndx_BANG__22(0);
return set_refresh_BANG__29((refresh_28 + 1));

})}></input>{((squint_core.truth_((() => {
const and_42_43 = document.hasFocus;
if (squint_core.truth_(and_42_43)) {
if (squint_core._EQ_(input_node_23.current, document.activeElement)) {
return squint_core.seq(results_7)} else {
return false}} else {
return and_42_43};

})())) ? ((() => {
const results_view_node_44 = useRef(null);
useEffect((function () {
if (squint_core.truth_(results_view_node_44)) {
return keep_selection_in_viewport(results_view_node_44.current, selected_ndx_21);
};

}), [selected_ndx_21]);
return <><div class="bg-white br1 br--bottom bb bl br b--blue w-100 absolute" style="top: 2.3rem; box-shadow: 0 4px 10px rgba(0,0,0,0.1)"><div className="bg-white br1 br--bottom bb bl br b--blue w-100 overflow-y-scroll" style={({"maxHeight": "20rem"})} ref={results_view_node_44}>{squint_core.vec(squint_core.lazy((function* () {
for (let G__45 of squint_core.iterable(squint_core.map_indexed(squint_core.vector, results_7))) {
const vec___46_49 = G__45;
const idx_50 = squint_core.nth(vec___46_49, 0, null);
const result_51 = squint_core.nth(vec___46_49, 1, null);
yield <div onMouseOver={(function () {
return set_selected_ndx_BANG__22(idx_50);

})} onMouseDown={(function () {
set_selected_ndx_BANG__22(idx_50);
return onActivateItem_10(squint_core.get(results_7, idx_50));

})}>{h(rowView_8, ({"result": result_51, "isSelected": squint_core._EQ_(selected_ndx_21, idx_50)}))}</div>;
}
return null;

})))}</div></div></>;

})()) : (null))}</div></>;

};

export { ListSearch }
